import { cornerRadiusLayer } from '@adaptive-web/adaptive-ui/reference';
import { css } from '@microsoft/fast-element';

export const imageHoverStyles = (imageSelector: string, filterSelector: string) => css`
	${imageSelector} {
		filter: grayscale(0);
		transition: filter 200ms ease;
	}

	${filterSelector} {
		opacity: 0;
	}
`;

export default css`
	:host {
		display: flex;
		position: relative;
		border-radius: ${cornerRadiusLayer};
		contain: content;
		box-sizing: border-box;
	}

	.filter {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #ffffff;
		transition: opacity 200ms ease;
		opacity: 0.3;
		z-index: 1;
		box-sizing: border-box;
	}
	
	.image-container {
		display: flex;
		filter: grayscale(1);
		margin-top: -3px;
    flex: 1;
		width: 100%;
		transition: filter 200ms ease-out;
		z-index: 0;
		box-sizing: border-box;
	}

	.image-container ::slotted(*) {
		display: flex;
		width: 100%;
		object-fit: cover;
	}
`;